export const SET_PARTNER_USERS = 'partner:setPartnerUsers'
export const SET_PARTNER_LABELS = 'partner:setPartnerLabels'